import { Box, Typography, useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import VerificationInput from "react-verification-input";
import {
  postForgetPassword,
  postResetPassword,
  postUserCheckCode,
  postUserCheckCodeForget,
} from "../api/signin";
import LockIcon from "../assets/SVG/lockIcon";
import PhoneIcon from "../assets/SVG/phoneIcon";
import PhoneIcon2 from "../assets/SVG/phoneIcon2";
import ProfileIcon from "../assets/SVG/profileIcon";
import Vector from "../assets/SVG/vector";
import InputLoginForm from "./login/inputLoginForm";
import Timer from "./signin/timer";

export default function ForgetPassForm() {
  const [level, setLevel] = useState(1);
  const [valueNID, setValueNID] = useState();
  const [newPass, setNewPass] = useState("");
  const [newPassRep, setNewPassRep] = useState();
  const [code, setCode] = useState();
  const [token, setToken] = useState();
  const [phone, setPhone] = useState();
  const md = useMediaQuery("(max-width:450px)");
  const navigate = useNavigate();
  // console.log(window.location);
  return (
    <Box display="grid" justifyContent={"center"}>
      {level === 1 && (
        <>
          <Typography
            sx={{
              color: "#2B2B2B",
              textAlign: "right",
              fontSize: "24px",
              fontStyle: "normal",
              fontWeight: "500",
              lineHeight: "120%",
              mb: "15px",
            }}
          >
            فراموشی رمز عبور
          </Typography>
          <InputLoginForm
          width={md?"250px":""}
            onChange={(e) => setValueNID(e.target.value)}
            value={valueNID}
            lable="نام کاربری"
            placeholder={"نام کاربری را وارد کنید."}
          >
            <ProfileIcon />
          </InputLoginForm>
          {/* <InputLoginForm
            onChange={(e) => {
              setPhone(e.target.value.replace(/\D/g, ""));
            }}
            inputProps={{ maxLength: 11 }}
            mt={"20px"}
            lable="شماره تلفن همراه"
            placeholder={"شماره تلفن همراه را وارد کنید."}
          >
            <PhoneIcon2 />
          </InputLoginForm> */}
          <button
            style={{
              display: "flex",
              marginTop: "20px",
              padding: "12px 24px",
              justifyContent: "center",
              alignItems: "center",
              gap: "8px",
              borderRadius: "8px",
              background: "#6CBBC7",
              boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
              border: "none",
              color: "white",
              fontSize: "16px",
              cursor: "pointer",
            }}
            onClick={() => {
              if (valueNID) {
                var formdata = new FormData();
                formdata.append("NID", valueNID);
                postForgetPassword(formdata)
                  .then((x) => {
                    setToken(x.token);
                    setLevel(2);
                  })
                  .catch((err) => {
                    // toast.error(err.data)
                  });
              } else {
                toast.error("فیلد را پر کنید");
              }
            }}
          >
            ارسال کد تایید
          </button>
        </>
      )}
      {level === 2 && (
        <>
          <Typography
            sx={{
              color: "#2B2B2B",
              textAlign: "right",
              fontSize: "24px",
              fontStyle: "normal",
              fontWeight: "500",
              lineHeight: "120%",
              mb: "50px",
            }}
          >
            فراموشی رمز عبور
          </Typography>
          <Box>
            <Box>
              <VerificationInput
                onChange={setCode}
                // inputField={{
                //   onChange: (e) => {
                //     // setValue(e.nativeEvent.target.value);
                //     console.log(e);
                //   },
                // }}
                length={6}
                validChars="0-9"
                removeDefaultStyles
                classNames={{
                  container: "container",
                  character: "character",
                  characterInactive: "character--inactive",
                  characterSelected: "character--selected",
                }}
              />
              <Timer initialMinute={2} initialSeconds={0} />
            </Box>
            <Box mt="20px" display="flex" justifyContent="center" height="70px">
              <button
                style={{
                  border: "none",
                  //   width: "150px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "white",
                  // boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
                  padding: "12px 0px",
                  marginTop: "20px",
                  borderRadius: "8px",
                }}
                onClick={() => setLevel(1)}
              >
                <Box sx={{ transform: "rotate(180deg)", mt: "-4px" }}>
                  <Vector color="#626262" />
                </Box>
                <Typography
                  fontWeight={"bold"}
                  fontSize="13px"
                  color="#626262"
                  mx="10px"
                >
                  ویرایش شماره تلفن همراه
                </Typography>
              </button>
              <button
                style={{
                  border: "none",
                  width: "150px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#6CBBC7",
                  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
                  padding: "12px 0px",
                  marginTop: "20px",
                  borderRadius: "8px",
                }}
                onClick={() => {
                  if (code) {
                    postUserCheckCodeForget({
                      token: token,
                      nid: valueNID,
                      code: code,
                    })
                      .then(() => setLevel(3))
                      .catch((err) => {});
                  }
                }}
              >
                <Typography fontSize="16px" color="white" ml="10px">
                  تایید
                </Typography>
              </button>{" "}
            </Box>
          </Box>
        </>
      )}
      {level === 3 && (
        <>
          <Typography
            sx={{
              color: "#2B2B2B",
              textAlign: "right",
              fontSize: "24px",
              fontStyle: "normal",
              fontWeight: "500",
              lineHeight: "120%",
              mb: "15px",
            }}
          >
            رمز عبور جدید
          </Typography>
          <InputLoginForm
            password
            onChange={(e) => setNewPass(e.target.value)}
            value={newPass}
            lable="رمز عبور"
            placeholder={"رمز عبور را وارد کنید."}
          >
            <LockIcon />
          </InputLoginForm>
          <InputLoginForm
            password
            inputProps={{ maxLength: newPass.length }}
            onChange={(e) => setNewPassRep(e.target.value)}
            value={newPassRep}
            lable="تکرار رمز عبور"
            placeholder={"رمز عبور را وارد کنید."}
          >
            <LockIcon />
          </InputLoginForm>
          <button
            style={{
              display: "flex",
              marginTop: "20px",
              padding: "12px 24px",
              justifyContent: "center",
              alignItems: "center",
              gap: "8px",
              borderRadius: "8px",
              background: "#6CBBC7",
              boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
              border: "none",
              color: "white",
              fontSize: "16px",
              cursor: "pointer",
            }}
            onClick={() => {
              if (newPass && newPassRep) {
                if (newPass === newPassRep) {
                  postResetPassword({
                    token: token,
                    nid: valueNID,
                    code: Number(code),
                    password: newPass,
                    repeatPassword: newPassRep,
                  })
                    .then(() => {
                      // setLevel(4);
                      navigate("/login");
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                } else {
                  toast.error("تکرار رمز اشتباه است");
                }
              } else {
                toast.error("لطفا فیلد ها را پر کنید");
              }
            }}
          >
            تایید
          </button>
        </>
      )}
    </Box>
  );
}
